module.exports = __webpack_public_path__ + "img/3dbd0fe.jpg";